import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { dataTemplateGetRequest } from "../../../../_redux/_actions";
import { Grid } from "@mui/material";

export default function DataTemplatesRowDetails(props) {
     const actionDispatch = useDispatch();

     const { details } = useSelector((state) => {
          return {
               details: state.dataTemplate.details,
          };
     });

     useEffect(() => {
          actionDispatch(dataTemplateGetRequest({ id: props.id }));
     }, []);

     return (
          <>   
               <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} lg={4}>
                         <strong>Name :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.name}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Template Type :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.type}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>InUse :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.inUse ? "Yes" : "No"}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Total Columns :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.totalColumns}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Total Records :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.totalRecords}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Deleted Records :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.deletedRecords}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Active :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.active ? "Yes" : "No"}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Created By :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.createdBy}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Created On :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.createdOn}
                    </Grid>
               </Grid>
          </>
     );
}
